import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUSES } from 'redux/statuses';
import { getMe } from 'services/users.service';

export const setUserIfEmpty = createAsyncThunk(
  'user/setUserIfEmpty',
  async (payload, { getState }) => {
    try {
      const { data } = await getMe();
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  {
    condition(payload, { getState }) {
      const { user } = getState();
      return user.status === STATUSES.EMPTY;
    },
  },
);

const initialState = {
  status: STATUSES.EMPTY,
  data: {},
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      return {
        status: STATUSES.FULFILLED,
        data: action.payload,
      };
    },
    unsetUser(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setUserIfEmpty.pending, (state, action) => {
        state.status = STATUSES.PENDING;
      })
      .addCase(setUserIfEmpty.fulfilled, (state, action) => {
        return {
          status: STATUSES.FULFILLED,
          data: action.payload,
        };
      });
  },
});

export const { setUser, unsetUser } = userSlice.actions;

export default userSlice.reducer;
